import { store } from '../../store'

export const deleteVideoCategory = async ( id: number ) => {

    let response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/2.0.0/cms/videos/categories/${ id }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'DELETE'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'DELETE_VIDEO_CATEGORY_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'DELETE_VIDEO_CATEGORY_UNAUTHORIZED' } )
        return

    }

    if ( response.status === 500 ) {

        store.dispatch( { type: 'DELETE_VIDEO_CATEGORY_ERROR' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'DELETE_VIDEO_CATEGORY_UNEXPECTEDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'DELETE_VIDEO_CATEGORY_OK' } )

}